import React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import type { SelectChangeEvent } from '@mui/material';

import {
  TRANSLATION_CLASS_NAMES,
  ELEMENT_IDS,
} from '../../utils/element-ids';
import InputError from '../InputError/InputError';
import noop from '../../utils/function/noop';

import DropdownOptions from './DropdownOptions';
import type { DropdownProps } from './types/DropDownTypes';

const Dropdown: React.FC<DropdownProps> = ({
  value,
  onChange,
  testid,
  isUsedByChildSession = false,
  disabled = false,
  id,
  options,
  name,
  errorMessage,
  onBlur = noop,
  inputLabel,
  renderValue,
}) => {
  const localOnChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const localOnBlur: React.FocusEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    onBlur(event.target.value);
  };

  return (
    <Box>
      {isUsedByChildSession ? (
        <InputLabel
          id={`${testid}-label`}
          data-testid={`${testid}-label`}
          sx={{
            fontSize: '.93rem',
            marginBottom: '8px',
            color: '#4B4D4F',
          }}
        >
          {inputLabel}
        </InputLabel>
      ) : null}

      <Select
        labelId={`${testid}-label`}
        id={`${id}-label`}
        value={value}
        variant="outlined"
        onChange={localOnChange}
        disabled={disabled}
        name={name}
        onBlur={localOnBlur}
        sx={{ width: '100%' }}
        className={
          TRANSLATION_CLASS_NAMES.NO_TRANSLATION_CLASS_NAME
        }
        renderValue={renderValue}
        data-testid={`${ELEMENT_IDS.DROPDOWN_SELECTOR}-${testid}`}
      >
        <DropdownOptions options={options} />
      </Select>
      {errorMessage ? (
        <Box>
          <InputError
            id={`${testid}-error`}
            errorMessage={errorMessage}
          />
        </Box>
      ) : null}
    </Box>
  );
};

export default Dropdown;
